/**
 * Construye URL pública para archivos en `api/uploads/` (y rutas relativas guardadas en BD).
 * Sin VITE_API_URL usa el prefijo `/api` (igual que axios) para que en dev el proxy
 * de Vite reenvíe a …/coonaltragasvite/api/uploads/…
 */
const UPLOAD_FILE_RE = /\.(jpe?g|png|gif|webp|pdf|docx?|xlsx?)$/i;

function normalizeAssetPath(path) {
  let p = String(path).trim().replace(/^\//, '');
  if (!p) return '';

  // Evita /api/api/uploads cuando en BD quedó "api/uploads/…"
  p = p.replace(/^api\//i, '');

  if (p.startsWith('uploads/')) return p;

  // Solo nombre de archivo → carpeta uploads del API
  if (!p.includes('/') && UPLOAD_FILE_RE.test(p)) {
    return `uploads/${p}`;
  }

  return p;
}

export function assetUrl(path) {
  if (!path) return '';
  const p = String(path).trim();
  if (!p) return '';
  if (/^https?:\/\//i.test(p)) return p;

  const normalized = normalizeAssetPath(p);
  if (!normalized) return '';

  const base = import.meta.env.VITE_API_URL?.replace(/\/$/, '') || '';
  if (!base) {
    return `/api/${normalized}`;
  }
  return `${base}/${normalized}`;
}
